import { render, staticRenderFns } from "./MainSectionJobOwner.vue?vue&type=template&id=f0bc70c4&"
import script from "./MainSectionJobOwner.vue?vue&type=script&lang=js&"
export * from "./MainSectionJobOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports